import { Button, Card, CardContent, Link as LinkFile, FormControl, FormControlLabel, FormLabel, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Tooltip, Typography, FormHelperText, SelectChangeEvent, Checkbox } from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './VerFormularioPeticao.module.css';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { telefoneMascara, dataBr, cpfMascara } from '../../util/mascaras';
import Head from '../../helper/Head';
import ShowImage from '../../components/ShowImage/ShowImage';
import Toast from '../../components/Toast/Toast';
import { FileText } from '@phosphor-icons/react';
import { objVazio } from '../../util/util';
import formularioPeticaoService from './service/formularioPeticao.service';
import Dialogo from '../../components/Dialogo/Dialogo';
import ModalComponent from '../../components/ModalComponent/ModalComponent';
import { UserContext } from '../../contexts/UserContext';
import ProgressoCircular from '../../components/ProgressoCircular/ProgressoCircular';


export default function VerFormularioPeticao() {

    const location = useLocation();
    const navigate = useNavigate();
    const [registroDenuncia, setRegistroDenuncia] = useState('');

    const { user_role } = useContext(UserContext);
    const [isToast, setIsToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastIcon, setToastIcon] = useState('');
    const [arquivosPeticao, setArquivosPeticao] = useState([] as any);
    const [selectedImage, setSelectedImage] = useState();
    const [showImage, setShowImage] = useState(false);
    const [grupoTrabalhoList, setGrupoTrabalhoList] = useState([] as any);
    const [grupoTrabalhoOutros, setGrupoTrabalhoOutros] = useState(false);
    const [statusDenunciaList, setStatusDenunciaList] = useState([] as any);
    const [statusDenuncia, setStatusDenuncia] = useState('');
    const [statusAcompanhamentoList, setStatusAcompanhamentoList] = useState([] as any);
    const [statusAcompanhamento, setStatusAcompanhamento] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [idFormularioPeticao, setIdFormularioPeticao] = useState('');
    const [botaoSEI, setbotaoSEI] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [isOpenProgressoCircular, setIsOpenProgressoCircular] = useState(false);
    const [numeroProcessoSEI, setNumeroProcessoSEI] = useState(null);
    const [isNumeroProcessoSEI, setIsNumeroProcessoSEI] = useState(false);

    const { register, handleSubmit, watch, setValue, clearErrors, formState: { errors } } = useForm();

    useEffect(() => {
        const id = location.pathname.split('/')[2];

        if (id !== '') {

            (async () => {
                const resp = await formularioPeticaoService.listStatusPeticao();

                const filtro = resp.filter((e:any) => parseInt(e.id) != 4);
                
                if (resp) {
                    setStatusDenunciaList(filtro);
                }
            })();

            (async () => {
                const resp = await formularioPeticaoService.listStatusAcompanhamento();
                if (resp)
                    setStatusAcompanhamentoList(resp);
            })();

            (async () => {
                const resp = await formularioPeticaoService.getFormularioPeticaoById(id);

                if (!!resp.formularioPeticao) {
                    const arquivos: any[] = [];
                    const statusDenuncia = resp.formularioPeticao.last_status.status_denuncia_id;
                    const statusAcompanhamento = resp.formularioPeticao.last_status.status_acompanhamento_id;
                    const comentarios = resp.formularioPeticao.last_status.comentarios;

                    if (resp.formularioPeticao.srcArquivosPeticao) {
                        resp.formularioPeticao.srcArquivosPeticao.forEach((e: any) => {
                            const isArquivo = (e.includes('.pdf') || e.includes('.doc') || e.includes('.mp4') || e.includes('.wmv') || e.includes('.avi')) ? true : false

                            arquivos.push({
                                arquivo: e,
                                docOuPdf: isArquivo
                            })
                        })
                    }

                    setArquivosPeticao(arquivos);
                    setRegistroDenuncia(resp.formularioPeticao.registroDenuncia);
                    setStatusDenuncia(statusDenuncia);
                    setValue('statusDenuncia', statusDenuncia);
                    setStatusAcompanhamento(statusAcompanhamento);
                    setValue('statusAcompanhamento', statusAcompanhamento);
                    setValue('comentarios', comentarios);

                    setValue('statusDenuncia', resp.formularioPeticao.statusAtual);
                    setValue('idFormularioPeticao', resp.formularioPeticao.idFormularioPeticao);
                    setValue('registroDenuncia', resp.formularioPeticao.registroDenuncia);
                    setValue('nome', resp.formularioPeticao.nome);
                    //setValue('cpf', cpfMascara(resp.formularioPeticao.cpf)); //aqui
                    setValue('documentoPessoal', resp.formularioPeticao.documentoPessoal);
                    //setValue('apelido', resp.formularioPeticao.apelido); //aqui
                    setValue('nomeSocial', resp.formularioPeticao.nomeSocial); 
                    //setValue('sexo', resp.formularioPeticao.sexo); //aqui
                    setValue('genero', resp.formularioPeticao.genero);
                    setValue('telefone', telefoneMascara(resp.formularioPeticao.telefone));
                    setValue('email', resp.formularioPeticao.email);
                    setValue('estadoUsuario', resp.formularioPeticao.estadoUsuario);
                    setValue('cidadeUsuario', resp.formularioPeticao.cidadeUsuario);
                    setValue('endereco', resp.formularioPeticao.endereco);
                    setValue('fato', resp.formularioPeticao.fato);
                    setValue('pedido', resp.formularioPeticao.pedido);
                    //setValue('dataEvento', dataBr(resp.formularioPeticao.dataEvento)); //aqui
                    setValue('dataViolacao', dataBr(resp.formularioPeticao.dataViolacao));
                    setValue('estadoOcorrencia', resp.formularioPeticao.estadoOcorrencia);
                    setValue('cidadeOcorrencia', resp.formularioPeticao.cidadeOcorrencia);
                    setValue('contatoEnvolvido', resp.formularioPeticao.contatoEnvolvido);

                    setIsNumeroProcessoSEI(resp.formularioPeticao.nr_processo_sei == null);
                    setNumeroProcessoSEI(resp.formularioPeticao.nr_processo_sei);
                    setIdFormularioPeticao(resp.formularioPeticao.idFormularioPeticao);

                    setValue('estadoMembro', resp.formularioPeticao.estadoMembro);

                    if(resp.formularioPeticao.nr_processo_sei == null){
                        if (resp.formularioPeticao.last_status.status_denuncia_id == 2 || resp.formularioPeticao.last_status.status_denuncia_id == 3) {
                            setbotaoSEI(false)
                        } else {
                            setbotaoSEI(true)
                        }
                    }

                    const data = await formularioPeticaoService.getGrupoTrabalho();

                    const grupoTrabalhos: any[] = []

                    data.forEach((e: any, i: any) => {
                        let grupoTrabalho = {};
                        resp.formularioPeticao.grupo_trabalho_dados.forEach((e1: any) => {
                            if (parseInt(e.idGrupoTrabalho) == parseInt(e1.idGrupoTrabalho)) {
                                grupoTrabalho = {
                                    idGrupoTrabalho: e.idGrupoTrabalho,
                                    atividade: e.atividade,
                                    checked: true
                                };

                                if (e1.outros !== null) {
                                    setGrupoTrabalhoOutros(true);
                                    setValue('grupoTrabalhoOutros', e1.outros);
                                }
                            }
                        });

                        if (!objVazio(grupoTrabalho)) {
                            grupoTrabalhos.push(grupoTrabalho)
                        } else {
                            grupoTrabalhos.push({
                                idAtividadeGarimpo: e.idAtividadeGarimpo,
                                atividade: e.atividade,
                                checked: false
                            });
                        }
                    });
                    setGrupoTrabalhoList(grupoTrabalhos);
                }
            })()
        }

    }, [botaoSEI, setbotaoSEI])

    const onSubmit = async (data: any) => {
        setOpenModal(false);
        setIsOpenProgressoCircular(true);

        let alteracaoStatus = {
            'idDenuncia': data.idFormularioPeticao,
            'statusDenuncia': parseInt(data.statusDenuncia),
            'statusAcompanhamento': data.statusAcompanhamento,
            'comentarios': data.comentarios
        };

        if (isNumeroProcessoSEI) {
            if (data.statusDenuncia == 2 || data.statusDenuncia == 3) {
                setbotaoSEI(false)
            } else {
                setbotaoSEI(true)
            }
        }

        const resp = await formularioPeticaoService.updateStatusDenuncia(alteracaoStatus);
        if (resp.response) {
            setIsOpenProgressoCircular(false);
            setToastMessage('Status alterado com sucesso!');
            setToastIcon('success');
        }
        else {
            setIsOpenProgressoCircular(false);
            setToastMessage('Erro ao alterar status!');
            setToastIcon('error');
        }

        setIsToast(true);

        setTimeout(() => {
            setIsToast(false);
            setOpenModal(false);
        }, 100)
    }

    function handleOpenPhotoFullWidth(e: any) {
        setSelectedImage(e.target);
        setShowImage(true);
    }

    const handleStatusDenuncia = (event: SelectChangeEvent) => {
        clearErrors('statusDenuncia');
        setStatusDenuncia(event.target.value);

        statusDenunciaList.forEach((e: any) => {
            if (e.id == event.target.value)
                setValue('statusDenuncia', e.id);
        });
    };

    const handleStatusAcompanhamento = (event: SelectChangeEvent) => {
        clearErrors('statusAcompanhamento');
        setStatusAcompanhamento(event.target.value);

        statusAcompanhamentoList.forEach((e: any) => {
            if (e.id == event.target.value)
                setValue('statusAcompanhamento', e.id);
        });
    };

    const handleDialogSubmit = async () => {
        setOpenDialog(false);

        setIsOpenProgressoCircular(true);

        const resp = await formularioPeticaoService.createProcessoSEI(idFormularioPeticao);

        if (!!resp) {
            setNumeroProcessoSEI(resp)
            setbotaoSEI(true)
            setToastMessage('Processo SEI criado com sucesso!');
            setToastIcon('success');

            setIsToast(true);

            setTimeout(() => {
                setIsToast(false);
            }, 100)
        }

        setIsOpenProgressoCircular(false);
    }


    return (
        <section className={`container-internal ${styles.verDenunciaSection}`}>
            <div className="animeRight">
                <Toast open={isToast} icon={toastIcon} mensagem={toastMessage} timer={3000} />
                <Head title=" | Visualizar petição" />
                <Card>
                    <CardContent>
                        <div className={styles.cardContent}>
                            <div className={styles.headCard}>
                                <h3 className="section-title">Denúncia Registro N°: {registroDenuncia}</h3>
                                <div className='row'>
                                    {/* <img src="../assets/imagens/sei.png" style={{ height: '40px', width: '70px' }} /> */}
                                    <div className='col'>
                                        <Button variant="contained" onClick={() => setOpenDialog(true)} disabled={botaoSEI} >
                                            <span>Gerar Processo SEI</span>
                                        </Button>
                                    </div>
                                    <div className='col'>
                                        <div className={styles.button}>
                                            <Button onClick={() => setOpenModal(true)}>
                                                <SaveIcon sx={{ fontSize: 25 }} />
                                                <span>Alterar status</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <input {...register('idFormularioPeticao', { required: true })} hidden /> {errors.idFormularioPeticao && 'idFormularioPeticao'}
                                    {numeroProcessoSEI &&
                                        <div className={styles.gridTop}>
                                            <TextField
                                                value={numeroProcessoSEI}
                                                className='mb-2 w-100'
                                                label="Numero do processo SEI"
                                                variant="outlined"
                                                type='text'
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </div>
                                    }
                                    <div className={styles.gridTop}>
                                        <TextField
                                            {...register('registroDenuncia', { required: false })}
                                            className='mb-2 w-100'
                                            label="Numero do registro da denúncia"
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            {...register('nome', { required: false })}
                                            className='mb-2 w-100'
                                            label="Nome completo"
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            {...register('documentoPessoal', { required: false })}
                                            className='mb-2 w-100'
                                            label="Documento Pessoal"
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            error={errors.estado ? true : false}
                                            helperText={errors.estado && 'Campo de estado esta vazio!'}
                                        />
                                        <TextField
                                            {...register('nomeSocial', { required: false })}
                                            className='mb-2 w-100'
                                            label="Nome Social"
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('genero', { required: false })}
                                            label="Gênero"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('telefone', { required: false })}
                                            label="Telefone"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('email', { required: false })}
                                            label="E-mail"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('estadoMembro', { required: false })}
                                            label="País"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('estadoUsuario', { required: false })}
                                            label="Estado"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('cidadeUsuario', { required: false })}
                                            label="Cidade"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('endereco', { required: false })}
                                            label="Endereço"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>

                                    <div className={styles.grid}>
                                        <FormControl >
                                            <FormLabel>
                                                Tema envolvido:
                                            </FormLabel>

                                            <div className='col'>
                                                {grupoTrabalhoList.length > 0 &&
                                                    <>
                                                        {grupoTrabalhoList.map((e: any, i: any) => (

                                                            <div key={i}>
                                                                <FormControlLabel
                                                                    {...register(`grupoTrabalho`, { required: false })}
                                                                    control={<Checkbox
                                                                        disabled
                                                                        checked={e.checked}
                                                                        style={{ color: errors.grupoTrabalho ? 'red' : '' }}
                                                                    />}
                                                                    label={''}
                                                                />
                                                                {<span style={{ color: errors.grupoTrabalho ? 'red' : '' }}>
                                                                    {e.atividade}
                                                                </span>
                                                                }
                                                            </div>
                                                        ))}

                                                        {(grupoTrabalhoOutros) &&
                                                            <TextField
                                                                {...register('grupoTrabalhoOutros', { required: true })}
                                                                label="Outro"
                                                                className='mb-3 w-100'
                                                                variant="outlined"
                                                                type='text'
                                                                InputLabelProps={{ shrink: true }}
                                                                inputProps={{ readOnly: true }}
                                                            />
                                                        }

                                                    </>
                                                }
                                            </div>
                                        </FormControl>

                                        <div>

                                            <TextField
                                                {...register('fato', { required: false })}
                                                className='mb-2 w-100'
                                                label="Descreva resumidamente os fatos"
                                                variant="outlined"
                                                type='text'
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                                multiline rows={10}
                                                error={errors.situacaoDescrita ? true : false}
                                                helperText={errors.situacaoDescrita && 'Campo de Descreva a situação esta vazio!'}
                                            />
                                            <TextField
                                                {...register('pedido', { required: false })}
                                                className='mb-2 w-100'
                                                label="Descreva resumidamente o que você está solicitando"
                                                variant="outlined"
                                                type='text'
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                                multiline rows={10}
                                                error={errors.situacaoDescrita ? true : false}
                                                helperText={errors.situacaoDescrita && 'Campo de Descreva a situação esta vazio!'}
                                            />
                                        </div>
                                    </div>

                                    <div className={styles.gridBottom}>
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('dataViolacao', { required: false })}
                                            label="Data da Violação"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('estadoOcorrencia', { required: false })}
                                            label="Estado da ocorrência"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            className='mb-2 w-100'
                                            {...register('cidadeOcorrencia', { required: false })}
                                            label="Cidade da ocorrência"
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            {...register('contatoEnvolvido', { required: false })}
                                            className='mb-2 w-100'
                                            label="Nome(s) da(s) pessoa(s) e/ou empresa(s) e/ou autoridade(s) e/ou órgão(s) responsáveis pelas violações"
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            error={errors.contatoEnvolvido ? true : false}
                                            helperText={errors.contatoEnvolvido && 'Campo de Contato esta vazio!'}
                                        />

                                    </div>

                                    <div className={styles.anexo}>
                                        <div className={styles.anexoHead}>
                                            <span className={styles.anexoTitle}>Arquivos anexados</span>
                                        </div>
                                        {arquivosPeticao.length > 0 ?
                                            <div className={styles.fotoAnexadas}>
                                                {
                                                    arquivosPeticao.map((foto: any, index: number) => (
                                                        <span key={index}>
                                                            {foto.docOuPdf ?
                                                                <LinkFile target='_blank' href={foto.arquivo}>
                                                                    <FileText size={28} color="#030303" weight="duotone" />
                                                                    Arquivo {index + 1}
                                                                </LinkFile>
                                                                :
                                                                <img key={index} onClick={handleOpenPhotoFullWidth} src={foto.arquivo} title="Arquivo" alt="Arquivo" />
                                                            }

                                                        </span>
                                                    ))
                                                }
                                            </div>
                                            :
                                            <p className={styles.semArquivos}>Não há arquivos anexados</p>
                                        }
                                    </div>

                                    <div className={styles.buttonVoltar}>
                                        <Link to='/list-formulario-peticao'>
                                            <Button>
                                                <ArrowBackIcon sx={{ fontSize: 30 }} />
                                                <span>Voltar</span>
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>

            {openModal &&
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalComponent
                        title="Alterar status denúncia"
                        closeModal={setOpenModal}
                    >
                        <div style={{ padding: '1rem' }}>
                            <FormControl error={errors.statusDenuncia ? true : false}>
                                <InputLabel>Status denúncia (*)</InputLabel>
                                <input {...register('statusDenuncia', { required: false })} value={statusDenuncia} hidden />
                                <Select
                                    value={statusDenuncia}
                                    label="Status denúncia (*)"
                                    onChange={handleStatusDenuncia}
                                    disabled={user_role != 1 && user_role != 2 ? true : false}
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                                >
                                    {!!statusDenunciaList ?
                                        statusDenunciaList.map((option: any, i: any) =>
                                            <MenuItem value={option.id} key={i}>{option.name}</MenuItem>
                                        )
                                        :
                                        <MenuItem value={0}>Nada a ser exibido</MenuItem>
                                    }
                                </Select>
                                {errors.statusDenuncia &&
                                    <FormHelperText>{errors.statusDenuncia.message?.toString()}</FormHelperText>
                                }
                            </FormControl>
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <FormControl error={errors.statusAcompanhamento ? true : false}>
                                <InputLabel>Status acompanhamento (*)</InputLabel>
                                <input {...register('statusAcompanhamento', { required: false })} hidden />
                                <Select
                                    value={statusAcompanhamento}
                                    label="Status acompanhamento (*)"
                                    onChange={handleStatusAcompanhamento}
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                                >
                                    {!!statusAcompanhamentoList ?
                                        statusAcompanhamentoList.map((option: any, i: any) =>
                                            <MenuItem value={option.id} key={i}>{option.name}</MenuItem>
                                        )
                                        :
                                        <MenuItem value={0}>Nada a ser exibido</MenuItem>
                                    }
                                </Select>
                                {errors.statusAcompanhamento &&
                                    <FormHelperText>{errors.statusAcompanhamento.message?.toString()}</FormHelperText>
                                }
                            </FormControl>
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <TextField
                                {...register('comentarios', { required: false, maxLength: 255 })}
                                label="Comentário(s)"
                                variant="outlined"
                                type='text'
                                autoComplete='off'
                                multiline rows={7}
                                InputLabelProps={{ shrink: true }}
                                error={errors.comentarios ? true : false}
                                helperText={errors.comentarios && errors.comentarios.message?.toString()}
                            />
                        </div>
                    </ModalComponent>
                </form>
            }

            <ShowImage
                showingImage={showImage}
                setShowImage={setShowImage}
                image={selectedImage}
            />

            <Dialogo
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                handleDialogSubmit={handleDialogSubmit}
                titulo={'Deseja realmente abrir um processo no sistema do SEI?'}
                conteudo={'Após concordar com esta ação o processo devera ser acompanhado no sistema SEI.'}
            />

            <ProgressoCircular open={isOpenProgressoCircular} />

        </section>

    )
}